import { FC } from 'react';
import { Container, Stack, Typography } from '@mui/material';
import Page from 'src/components/molecules/page';
import { InformationForm } from 'src/components/organisms/photo-studio/detail/information/form';

export const InformationCreatePage: FC = () => {
  const title = '詳細情報登録';

  return (
    <Page title={title}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {title}
          </Typography>
        </Stack>
        <InformationForm />
      </Container>
    </Page>
  );
};
